import { useEffect, useState } from 'react';
import { Eyebrow } from '@/components/ui/Typography';
import { stationsApi } from '@/api/stations';

// Amostra baixa demais deixa o gráfico enganoso (1-2 sessões espalhadas
// parecem "pico" quando não são nada) — melhor esconder do que mostrar ruído.
const MIN_SAMPLE_SIZE = 20;

/**
 * "Horários de pico" — distribuição real de sessões por hora do dia, últimos
 * 90 dias (feedback Saulo 2026-07-06: existia só como mock fixo no design
 * original, agora usa `GET /stations/:id/peak-hours`). Esconde por completo
 * se a estação ainda não tem histórico suficiente ou o fetch falhar.
 */
export function PeakHoursChart({ stationId }: { stationId: string }) {
  const [hours, setHours] = useState<number[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    setHours(null);
    stationsApi
      .peakHours(stationId)
      .then((res) => {
        if (cancelled) return;
        setHours(res.sample_size >= MIN_SAMPLE_SIZE ? res.hours : []);
      })
      .catch(() => {
        if (!cancelled) setHours([]);
      });
    return () => {
      cancelled = true;
    };
  }, [stationId]);

  if (!hours || hours.length === 0) return null;

  const max = Math.max(...hours, 1);
  const currentHour = new Date().getHours();

  return (
    <div className="flex flex-col gap-2">
      <Eyebrow>Horários de pico</Eyebrow>
      <div className="flex h-14 items-end gap-[3px]">
        {hours.map((count, hour) => (
          <div
            key={hour}
            className="min-w-0 flex-1 rounded-[2px]"
            style={{
              height: `${Math.max((count / max) * 100, 6)}%`,
              background: hour === currentHour ? '#001B74' : 'rgba(0,27,116,0.12)'
            }}
            title={`${hour}h · ${count} sessões`}
          />
        ))}
      </div>
      <div className="flex justify-between text-[10px] text-bow-royal/45">
        <span>0h</span>
        <span>6h</span>
        <span>12h</span>
        <span>18h</span>
        <span>23h</span>
      </div>
    </div>
  );
}
